import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { getRequestIdFromResponse, httpGet } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
/**
 * Get a drive item from OneDrive or SharePoint
 * Ref: https://docs.microsoft.com/en-us/graph/api/driveitem-get-content?view=graph-rest-1.0&tabs=http
 * @param driveId Drive id where item lives
 * @param itemId Id of the item
 * @param graphXhrOptions Parameters needed to create a web request
 * @param queryParams Additional query parameter, such as <'select', 'id,content.downloadUrl'> or format <'format', 'PDF'>
 * @param sharePointInfo if the drive item lives in a sharePoint site, we also need the siteUrl
 * @returns Promise with a GraphDriveItem
 * */
export function fetchDriveItem(_a) {
    var driveId = _a.driveId, isContentRequest = _a.isContentRequest, itemId = _a.itemId, graphXhrOptions = _a.graphXhrOptions, queryParams = _a.queryParams, contentResponseType = _a.contentResponseType, sharePointIds = _a.sharePointIds;
    return __awaiter(this, void 0, void 0, function () {
        var apiPath, url, requestConfig;
        return __generator(this, function (_b) {
            if (!driveId || !itemId) {
                return [2 /*return*/, Promise.reject('Invalid ids')];
            }
            if (!graphXhrOptions) {
                return [2 /*return*/, Promise.reject('Invalid graphXhrOptions')];
            }
            apiPath = "drives/".concat(driveId, "/items/").concat(itemId);
            if (sharePointIds) {
                apiPath = "sites/".concat(sharePointIds.siteId, "/drive/items/").concat(itemId);
            }
            // Add content path if content is requested
            if (isContentRequest) {
                apiPath += '/content';
            }
            url = getGraphServiceEndpoint(graphXhrOptions.graphApiRoot, apiPath, false, queryParams);
            requestConfig = {
                method: "GET" /* HttpRequestMethod.Get */,
                responseType: contentResponseType,
            };
            return [2 /*return*/, httpGet(KnownInstrumentationEvents.OneDriveGraphItemRequest, "OneDrive_Graph_Item" /* KnownRequestInstrumentationEvents.OneDriveGraphItemRequest */, url, requestConfig, graphXhrOptions.jwtAuthEnabled, graphXhrOptions.getAccessToken, graphXhrOptions.officeApiRoot, graphXhrOptions.correlationId, 'Graph', {
                    populateRequestEvent: function (response, params) {
                        params["RequestId" /* InstrumentationParam.RequestId */] =
                            getRequestIdFromResponse(response) || '';
                    },
                }).then(function (response) {
                    if (!response || !response.ok || response.data === undefined) {
                        // $TODO: Add additional parameters here and throw a 'GraphError' instead
                        // with error code, inner error code as well as the response status code
                        // see convertUploadDriveItem in actions-executor for examples of what is needed here.
                        throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'Graph API error');
                    }
                    return response.data;
                })];
        });
    });
}
//# sourceMappingURL=fetchDriveItem.js.map